import { createContext, useContext } from 'react';

export const WindowManagerContext = createContext({
  openWindow: () => {},
  openCaseStudy: () => {},
  openPalette: () => {},
});

export const useWindowManager = () => useContext(WindowManagerContext);
